import { ObjectFilter } from 'components/page/index';
import React, { Fragment } from 'react';

const ObjectView = ({ match }) => {
  const { viewId, objectType } = match.params;
  return (
    <Fragment>
      <ObjectFilter
        viewId={viewId}
        objectType={objectType}
        needSearchBar
      />
      {/* <ObjectView__REFACTORED /> */}
    </Fragment>
  );
};


export default ObjectView;



// WEBPACK FOOTER //
// ./src/views/ObjectView/container/index.jsx